<script setup lang="ts">
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { type PropType, reactive, watch } from 'vue'

const props = defineProps({
  field: {
    type: Object as PropType<ObjectInventoryField>,
    required: true,
  },
  hideMandatory: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update'])

const currentValues = reactive({
  length: props.field?.length || 0,
  mandatory: Boolean(props.field?.mandatory),
})

/** Обновляем данные поля */
watch(currentValues, () => {
  emits('update', { ...props.field, ...currentValues })
})
</script>

<template>
  <VTextField type="number" :label="$t('itf.field_length')" v-model="currentValues.length" />
  <VCheckbox
    v-if="!hideMandatory"
    class="ml-3"
    v-model="currentValues.mandatory"
    :label="$t('itf.required')"
  />
</template>
